export interface Comic {
  id: number;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  status: '连载' | '完结';
  chapters: number;
  latestChapter: string;
  rating: number;
  views: string;
  updatedAt: string;
  intro: string;
  cover: string;
  isHot?: boolean;
  isPick?: boolean;
}

export const GENRES = ['全部', '古风', '现代言情', '甜宠', '校园', '都市', '重生', '穿越', '总裁'];

export const comics: Comic[] = [
  {
    id: 1,
    title: '桃花醉',
    author: '折枝画',
    genre: '古风',
    tags: ['重生', '权谋', '双向奔赴'],
    status: '连载',
    chapters: 286,
    latestChapter: '第286话 此生共白首',
    rating: 9.4,
    views: '368.2万',
    updatedAt: '2小时前',
    intro: '一朝重生，桃花阁首席画师云晚被退婚沦为弃女。前世她将真心捧给那个负心人，这一世她要为自己而活。谁能想到，那个传说中冷面冷心的摄政王，却一次次将她护在身后，桃花树下，他低声道："这天下，都不及你手中一支桃花。"',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20romance%20webtoon%20cover%2C%20graceful%20young%20woman%20in%20flowing%20pale%20pink%20hanfu%20holding%20a%20blooming%20peach%20blossom%20branch%2C%20warm%20peach%20and%20cream%20color%20palette%2C%20drifting%20petals%20and%20soft%20pastel%20clouds%20in%20background%2C%20dreamy%20gentle%20lighting%2C%20refined%20delicate%20line%20art%2C%20high%20quality%20romantic%20manga%20cover%20illustration%20portrait&width=600&height=800&seq=cover-01&orientation=portrait',
    isHot: true,
    isPick: true,
  },
  {
    id: 2,
    title: '朝暮与你',
    author: '奶油拿铁',
    genre: '校园',
    tags: ['青春', '暗恋', '治愈'],
    status: '连载',
    chapters: 152,
    latestChapter: '第152话 毕业照的约定',
    rating: 9.1,
    views: '201.6万',
    updatedAt: '5小时前',
    intro: '高二那年，林朝夕搬进新班级，同桌是年级第一的冷面学霸顾朝暮。一个是爱睡懒觉的小话痨，一个是一句废话都嫌多的学神，本该毫无交集的两个人，却在一次次点名、一次次同桌的较量里，悄悄写下了整个青春的秘密。',
    cover: 'https://readdy.ai/api/search-image?query=Sweet%20high%20school%20romance%20manga%20cover%2C%20cheerful%20young%20girl%20with%20short%20hair%20and%20a%20serious%20boy%20classmate%20sitting%20at%20desks%2C%20warm%20peach%20and%20soft%20yellow%20palette%2C%20cherry%20blossom%20trees%20through%20classroom%20window%2C%20cute%20youthful%20anime%20illustration%2C%20clean%20gentle%20line%20art%2C%20romantic%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-02&orientation=portrait',
    isHot: true,
  },
  {
    id: 3,
    title: '首席的心尖宠',
    author: '南风知我意',
    genre: '总裁',
    tags: ['先婚后爱', '甜蜜', '职场'],
    status: '连载',
    chapters: 198,
    latestChapter: '第198话 被你宠上瘾',
    rating: 9.2,
    views: '245.8万',
    updatedAt: '1小时前',
    intro: '一场意外的契约婚姻，让她从天之骄女沦为被家族抛弃的小白兔，却撞上了传闻中不近女色的首席总裁沈以深。"嫁给我，股份归你。"他语气冷淡，却在她走错路时轻轻牵住她的手。人人都说沈总冷血无情，只有她知道，这位冰山总裁，早已把温柔都给了她。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20romance%20manga%20cover%2C%20elegant%20woman%20in%20white%20office%20dress%20and%20handsome%20man%20in%20dark%20suit%20standing%20close%20in%20city%20skyline%20at%20sunset%2C%20warm%20peach%20golden%20lighting%2C%20soft%20city%20bokeh%20background%2C%20refined%20anime%20illustration%2C%20romantic%20corporate%20love%20story%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-03&orientation=portrait',
    isHot: true,
  },
  {
    id: 4,
    title: '一梦千年',
    author: '月下长歌',
    genre: '古风',
    tags: ['穿越', '甜宠', '玄幻'],
    status: '连载',
    chapters: 312,
    latestChapter: '第312话 跨越千年的重逢',
    rating: 9.5,
    views: '412.7万',
    updatedAt: '30分钟前',
    intro: '一场高烧，让现代中医系学生苏晚穿越千年，成为将军府最不受宠的庶女。前世被人踩在脚下，这一世她凭一手绝妙医术翻云覆雨。当她救下那个命悬一线的少年将军，却不知，这段跨越千年的缘分，早已在另一个时空悄然埋下。',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20ancient%20Chinese%20romance%20manga%20cover%2C%20young%20woman%20in%20elegant%20teal%20and%20pink%20hanfu%20with%20glowing%20medicinal%20herb%20in%20hand%2C%20young%20general%20in%20armor%20beside%20her%2C%20warm%20peach%20and%20jade%20color%20palette%2C%20misty%20palace%20background%20with%20lanterns%2C%20epic%20dreamy%20anime%20illustration%2C%20romantic%20fantasy%20webtoon%20portrait&width=600&height=800&seq=cover-04&orientation=portrait',
    isHot: true,
    isPick: true,
  },
  {
    id: 5,
    title: '甜蜜陷阱',
    author: '一颗小甜橙',
    genre: '甜宠',
    tags: ['轻松', '宠妻', '搞笑'],
    status: '连载',
    chapters: 176,
    latestChapter: '第176话 今天也爱你',
    rating: 9.0,
    views: '188.3万',
    updatedAt: '昨天',
    intro: '甜品店老板娘宋甜甜最大的愿望，是安稳经营自己的小蛋糕店。可自从那位每天准时来买同一款蛋糕的高冷男神走进店里，她的生活就彻底乱套了。这个男人总是一本正经地"碰巧"出现，然后云淡风轻地，把她宠成了最甜的奶油。',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20sweet%20romance%20manga%20cover%2C%20smiling%20girl%20baker%20in%20pastel%20apron%20holding%20strawberry%20cake%2C%20gentle%20handsome%20man%20peeking%20from%20bakery%20door%2C%20warm%20cream%20and%20pink%20palette%2C%20cozy%20dessert%20shop%20background%2C%20adorable%20cheerful%20anime%20illustration%2C%20fluffy%20lighthearted%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '春风入怀',
    author: '扶苏公子',
    genre: '古风',
    tags: ['温柔', '甜宠', '民间'],
    status: '完结',
    chapters: 120,
    latestChapter: '完结番外',
    rating: 9.3,
    views: '156.9万',
    updatedAt: '3天前',
    intro: '江南小镇，药铺掌柜温知夏与落魄书生陆春风因一场误会相识。一个温婉坚韧，一个清冷腹黑，两人从互不待见，到携手经营药铺、庇护乡里。春风不解风情，却只把所有的偏爱，都悄悄吹进了知夏的心底。',
    cover: 'https://readdy.ai/api/search-image?query=Gentle%20ancient%20Chinese%20romance%20manga%20cover%2C%20soft%20young%20woman%20in%20pale%20blue%20and%20pink%20dress%20standing%20by%20a%20small%20herbal%20shop%2C%20scholarly%20young%20man%20reading%20a%20book%20nearby%2C%20warm%20spring%20peach%20blossom%20and%20willow%20palette%2C%20misty%20Jiangnan%20town%20background%2C%20tender%20serene%20anime%20illustration%2C%20romantic%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-06&orientation=portrait',
  },
  {
    id: 7,
    title: '草莓味的夏天',
    author: '气泡柠檬',
    genre: '校园',
    tags: ['初恋', '青春', '成长'],
    status: '连载',
    chapters: 98,
    latestChapter: '第98话 草莓汽水的告白',
    rating: 8.9,
    views: '120.4万',
    updatedAt: '6小时前',
    intro: '高二那年夏天，转学生夏知夏误把全校闻名的小霸王陆北辰当成了女生，还追着人家问"草莓味汽水在哪儿"。一个炸毛暴躁，一个天然呆萌，鸡飞狗跳的同桌生活里，少年少女的初恋，像一罐冰镇的草莓汽水，咕嘟咕嘟冒着甜甜的气泡。',
    cover: 'https://readdy.ai/api/search-image?query=Playful%20youth%20romance%20manga%20cover%2C%20cute%20girl%20holding%20strawberry%20soda%20bottle%20and%20cool%20boy%20in%20school%20uniform%20looking%20flustered%2C%20bright%20strawberry%20pink%20and%20cream%20palette%2C%20summer%20school%20rooftop%20background%20with%20blue%20sky%2C%20energetic%20cheerful%20anime%20illustration%2C%20youthful%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-07&orientation=portrait',
  },
  {
    id: 8,
    title: '隐婚甜妻',
    author: '莫染',
    genre: '现代言情',
    tags: ['隐婚', '总裁', '甜宠'],
    status: '连载',
    chapters: 224,
    latestChapter: '第224话 公开！',
    rating: 9.1,
    views: '276.5万',
    updatedAt: '昨天',
    intro: '小职员顾浅浅被老板逼着相亲，随手一指，居然点了全城最有钱的大佬陆擎天。为了应付家族逼婚，两人一拍即合、火速隐婚。白天他是高高在上的总裁，晚上是她的"临时老公"。只是她没想到，这位赫赫有名的陆总，宠起老婆来，简直是行走的撒糖机器。',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20modern%20manga%20cover%2C%20pretty%20office%20girl%20and%20tall%20handsome%20CEO%20in%20tuxedo%20exchanging%20ring%20at%20night%2C%20warm%20gold%20and%20blush%20pink%20city%20night%20bokeh%2C%20secret%20marriage%20theme%2C%20elegant%20mature%20anime%20illustration%2C%20luxurious%20sweet%20romance%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-08&orientation=portrait',
  },
  {
    id: 9,
    title: '锦瑟年华',
    author: '青玉案',
    genre: '古风',
    tags: ['虐恋', '权谋', 'he'],
    status: '完结',
    chapters: 156,
    latestChapter: '完结大结局',
    rating: 9.2,
    views: '189.7万',
    updatedAt: '一周前',
    intro: '锦瑟无端五十弦，一弦一柱思华年。当朝太傅之女谢锦瑟，本与太子青梅竹马，却在一夜之间家破人亡、坠入深渊。多年后她披着新身份归来，步步为营只为复仇，却在刀光剑影里，重新遇见了那个仍为她留灯的人。',
    cover: 'https://readdy.ai/api/search-image?query=Melancholy%20ancient%20Chinese%20romance%20manga%20cover%2C%20beautiful%20woman%20in%20elaborate%20crimson%20and%20gold%20hanfu%20with%20tears%20in%20eyes%2C%20distant%20royal%20palace%20with%20lanterns%2C%20deep%20red%20and%20warm%20cream%20palette%2C%20dramatic%20misty%20atmosphere%2C%20tragic%20yet%20hopeful%20anime%20illustration%2C%20historical%20love%20story%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-09&orientation=portrait',
  },
  {
    id: 10,
    title: '月下遇卿',
    author: '半盏流年',
    genre: '古风',
    tags: ['玄幻', '神仙', '守护'],
    status: '连载',
    chapters: 168,
    latestChapter: '第168话 月老的红线',
    rating: 9.0,
    views: '142.8万',
    updatedAt: '4小时前',
    intro: '小仙娥清月偷溜下凡游玩，误打误撞救下了重伤的冷面战神暮云归。从此，高高在上的神君成了她的"跟班"，从天界追到人间，从初雪追到花开。她不知道，这场相遇不是偶然，而是三界最漫长的一场深情等待。',
    cover: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20romance%20manga%20cover%2C%20young%20fairy%20girl%20in%20soft%20peach%20celestial%20robes%20and%20silver%20armored%20god%20under%20a%20glowing%20full%20moon%2C%20warm%20silver%20and%20peach%20palette%2C%20drifting%20clouds%20and%20stars%2C%20luminous%20magical%20anime%20illustration%2C%20divine%20love%20story%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-10&orientation=portrait',
  },
  {
    id: 11,
    title: '与你初相识',
    author: '晚风微凉',
    genre: '现代言情',
    tags: ['职场', '治愈', '双向暗恋'],
    status: '连载',
    chapters: 134,
    latestChapter: '第134话 幸好是你',
    rating: 8.8,
    views: '98.6万',
    updatedAt: '今天',
    intro: '初入职场的安小雨，面对一堆棘手项目手足无措，却总能得到隔壁部门那个寡言同事的帮助。从递一杯咖啡，到深夜加班送她回家，这段从未说破的暗恋，在一次次细水长流的温柔里，慢慢长成了双向奔赴的告白。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20modern%20workplace%20romance%20manga%20cover%2C%20young%20office%20woman%20and%20kind%20male%20colleague%20sharing%20coffee%20at%20late%20night%20office%2C%20warm%20amber%20and%20cream%20palette%2C%20cozy%20city%20lights%20through%20window%2C%20soft%20gentle%20anime%20illustration%2C%20quiet%20heartfelt%20romance%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-11&orientation=portrait',
  },
  {
    id: 12,
    title: '宠你上瘾',
    author: '糖分超标',
    genre: '甜宠',
    tags: ['轻松', '宠妻', '搞笑'],
    status: '完结',
    chapters: 110,
    latestChapter: '完结撒花',
    rating: 9.0,
    views: '168.2万',
    updatedAt: '5天前',
    intro: '综艺里，傲娇顶流影帝贺屿被节目组安排和一个素人女孩组队。原以为会冷场，谁知这位大明星彻底"人设崩塌"，又是剥虾又是撑伞，把小姑娘宠上了天。全网都在磕这对CP，只有他知道，他是真的，对她上瘾了。',
    cover: 'https://readdy.ai/api/search-image?query=Fun%20celebrity%20romance%20manga%20cover%2C%20famous%20actor%20man%20carrying%20umbrella%20for%20shy%20girl%20at%20outdoor%20variety%20show%2C%20bright%20sunny%20warm%20palette%2C%20pink%20and%20peach%20bokeh%2C%20lively%20cute%20anime%20illustration%2C%20celebrity%20couple%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-12&orientation=portrait',
  },
  {
    id: 13,
    title: '白月光归来',
    author: '一梦千年',
    genre: '现代言情',
    tags: ['重生', '爽文', 'he'],
    status: '连载',
    chapters: 204,
    latestChapter: '第204话 白月光大作战',
    rating: 9.3,
    views: '258.1万',
    updatedAt: '2小时前',
    intro: '前世，她是被绿茶妹妹抢走一切的白月光；今生，她带着记忆归来，誓要把属于自己的一点点夺回。当渣男前任、塑料姐妹一一现形，那位前世被她辜负的顶流总裁，却红着眼眶将她堵在墙角："这一次，换我追你。"',
    cover: 'https://readdy.ai/api/search-image?query=Empowering%20romance%20manga%20cover%2C%20confident%20beautiful%20woman%20in%20elegant%20white%20dress%20walking%20forward%2C%20handsome%20determined%20man%20reaching%20toward%20her%2C%20bright%20warm%20sunrise%20palette%2C%20modern%20city%20background%2C%20stylish%20bold%20anime%20illustration%2C%20revenge%20romance%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-13&orientation=portrait',
  },
  {
    id: 14,
    title: '王爷的宠妃',
    author: '画中仙',
    genre: '古风',
    tags: ['宫斗', '权谋', '宠妻'],
    status: '连载',
    chapters: 268,
    latestChapter: '第268话 凤冠霞帔',
    rating: 9.4,
    views: '321.9万',
    updatedAt: '昨天',
    intro: '穿成注定被废的炮灰王妃，苏浅浅决定摆烂躺平。可那位传闻中冷血阴鸷的定北王，却把她宠上了天：怕她冷，冬日暖炉铺到脚边；怕她累，皇宫的活儿全包。她只想低调求生，偏生这位王爷，恨不得把整座王府的宠爱都塞给她。',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20royal%20romance%20manga%20cover%2C%20elegant%20woman%20in%20ornate%20phoenix%20pink%20hanfu%20and%20domineering%20prince%20in%20dark%20brocade%20robes%2C%20warm%20red%20gold%20and%20peach%20palette%2C%20luxurious%20palace%20interior%20with%20silk%20curtains%2C%20majestic%20dramatic%20anime%20illustration%2C%20royal%20concubine%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-14&orientation=portrait',
    isHot: true,
  },
  {
    id: 15,
    title: '心动便利店',
    author: '桃子汽水',
    genre: '都市',
    tags: ['治愈', '日常', '邻居'],
    status: '连载',
    chapters: 86,
    latestChapter: '第86话 便利店的小确幸',
    rating: 8.7,
    views: '76.4万',
    updatedAt: '今天',
    intro: '凌晨两点的便利店，加班到崩溃的都市白领林晚晚，总能在收银台前遇见那个每次都买同一款关东煮的温柔大叔。没有轰轰烈烈的桥段，只有每一个深夜的慰藉与陪伴。原来真正的治愈，就藏在日复一日的"晚上好"里。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20slice%20of%20life%20romance%20manga%20cover%2C%20tired%20office%20lady%20and%20warm%20gentle%20man%20at%20small%20convenience%20store%20counter%20at%20night%2C%20warm%20yellow%20cream%20and%20soft%20green%20palette%2C%20glowing%20storefront%20with%20warm%20lights%2C%20soothing%20heartwarming%20anime%20illustration%2C%20daily%20life%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-15&orientation=portrait',
  },
  {
    id: 16,
    title: '退婚之后我成了团宠',
    author: '软软团子',
    genre: '古风',
    tags: ['团宠', '轻松', '甜爽'],
    status: '连载',
    chapters: 142,
    latestChapter: '第142话 全家宠翻天',
    rating: 9.1,
    views: '167.5万',
    updatedAt: '3小时前',
    intro: '重生归来，姜软决定远离渣男未婚夫，安心抱紧家里几位大佬哥哥的大腿。可谁知，从前对她冷淡的哥哥们一个个化身"宠妹狂魔"，就连前世冷心冷情的太子爷，也成了她身后最忠实的守护者。她说：我只想咸鱼翻身，你们怎么都来宠我？',
    cover: 'https://readdy.ai/api/search-image?query=Playful%20family%20romance%20manga%20cover%2C%20cute%20spoiled%20girl%20in%20soft%20pink%20hanfu%20surrounded%20by%20doting%20handsome%20older%20brothers%2C%20warm%20peach%20and%20cream%20palette%2C%20happy%20garden%20background%20with%20koi%20pond%2C%20cheerful%20endearing%20anime%20illustration%2C%20family%20pampering%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-16&orientation=portrait',
  },
  {
    id: 17,
    title: '学神的恋爱笔记',
    author: '夏目拾荒',
    genre: '校园',
    tags: ['高智商', '欢喜冤家', '学霸'],
    status: '连载',
    chapters: 118,
    latestChapter: '第118话 满分试卷换约会',
    rating: 8.9,
    views: '133.7万',
    updatedAt: '昨天',
    intro: '数学天才苏北是全校公认的学神，也是出了名的恋爱绝缘体。直到他收到一封匿名情书，从那天起，他的人生多了三个难题：这道题怎么做、这个女生是谁、以及——怎么用一套满分试卷，换她一句"我喜欢你"。',
    cover: 'https://readdy.ai/api/search-image?query=Clever%20school%20romance%20manga%20cover%2C%20genius%20boy%20with%20glasses%20solving%20math%20equations%20and%20shy%20girl%20peeking%20with%20a%20love%20letter%2C%20bright%20warm%20yellow%20and%20cream%20palette%2C%20library%20background%20with%20books%2C%20witty%20smart%20anime%20illustration%2C%20academic%20rivals%20romance%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-17&orientation=portrait',
  },
  {
    id: 18,
    title: '偏偏喜欢你',
    author: '岛屿来信',
    genre: '都市',
    tags: ['青春', '重逢', 'he'],
    status: '完结',
    chapters: 96,
    latestChapter: '完结大结局',
    rating: 8.8,
    views: '105.3万',
    updatedAt: '一周前',
    intro: '五年前，林默与许安然因误会分开，一个远走他乡，一个留在原地。五年后重逢，他们都已褪去青涩，却都还守着当年那份没说出口的喜欢。这一次，哪怕全世界都反对，他也要坚定地告诉她：这辈子，我就偏偏喜欢你。',
    cover: 'https://readdy.ai/api/search-image?query=Heartfelt%20reunion%20romance%20manga%20cover%2C%20mature%20young%20man%20and%20woman%20meeting%20again%20on%20a%20seaside%20street%20at%20dusk%2C%20warm%20rose%20and%20amber%20palette%2C%20ocean%20and%20sunset%20background%2C%20emotional%20tender%20anime%20illustration%2C%20reunion%20love%20story%20webtoon%20cover%20portrait&width=600&height=800&seq=cover-18&orientation=portrait',
  },
];

export const hotComics = comics.filter((c) => c.isHot);
export const pickComics = comics.filter((c) => c.isPick);
export const latestComics = [...comics].sort((a, b) => a.id % 3 - (b.id % 3));

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelated(comic: Comic, count = 4): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id)
    .sort((a, b) => (a.genre === comic.genre ? 0 : 1) - (b.genre === comic.genre ? 0 : 1))
    .slice(0, count);
}